module.exports = __webpack_public_path__ + "static/media/Mesa-XM2.4d7a2e86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/productos/Mesa-XM2.jpg
// module id = 146
// module chunks = 0